
export const USER_SUBSCRIPTION_FREE = "free";
export const USER_SUBSCRIPTION_PREMIUM = "premium";

export const USER_SUBSCRIPTIONS = [
    USER_SUBSCRIPTION_FREE,
    USER_SUBSCRIPTION_PREMIUM,
];